import { Header, withLayout } from '@/components';
import { CompanyPrivacy } from '@/components/company/CompanyPrivacy';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="プライバシーポリシー" />
      <Header />
      <CompanyPrivacy />
    </>,
  );
};

export default Page;
